import { constant } from "./TeacherActionsConstants";
let initialState = {
    saveTeacherInProgress:false
}

export const TeacherReducer = (state = initialState  , action ) =>{
    switch(action.type){
        case constant.SAVE_TEACHER_IN_PROGRESS:
            return{...state , saveTeacherInProgress:true};
        case constant.SAVE_TEACHER_COMPLETE:
            return{...state , saveTeacherInProgress:false ,data:action.data}
        default :
            return state
    }
}
  
export default TeacherReducer;